// src/pages/Settings/tabs/AppearanceTab.js
import React from 'react';
import { useProfile } from '../../../context/ProfileContext';

const AppearanceTab = () => {
    const { isDarkMode, toggleDarkMode } = useProfile();

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex items-center justify-between p-4 bg-white dark:bg-brand-gray/20 rounded-2xl border border-slate-100 dark:border-brand-gray transition-colors">
                <div>
                    <h3 className="font-bold dark:text-brand-white">Dark Mode</h3>
                    <p className="text-xs text-slate-500 dark:text-slate-400">
                        Switch between light and dark themes.
                    </p>
                </div>
                
                <button 
                    onClick={toggleDarkMode}
                    className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all ${
                        isDarkMode ? 'bg-brand-pink' : 'bg-slate-300'
                    }`}
                >
                    <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                            isDarkMode ? 'translate-x-6' : 'translate-x-1'
                        }`}
                    />
                </button>
            </div>
        </div>
    );
};

export default AppearanceTab;